/**
 * Shuttle Header Form Handler
 * Handles the disabled form in step-2 header
 * 
 * @package A2A_Theme
 */

(function($) {
    'use strict';

    /**
     * Header Form Handler
     */
    class ShuttleHeaderFormHandler {
        constructor() {
            this.form = $('#shuttle-booking-form-header');
            this.manager = window.shuttleBookingManager;
            this.isInitialized = false;
            
            // Form elements
            this.elements = {
                transferTypeRadios: $('input[name="transfer_type-header"]'),
                fromSelectDesktop: $('#shuttle-from-select-header'),
                toSelectDesktop: $('#shuttle-to-select-header'),
                outboundDateDesktop: $('#shuttle-outbound-date-header'),
                returnDateDesktop: $('#shuttle-return-date-header'),
                passengersDesktop: $('#shuttle-passengers-header'),
                backBtn: $('#shuttle-back-btn')
            };
            
            this.init();
        }
        
        /**
         * Initialize header form
         */
        async init() {
            if (this.isInitialized || !this.form.length) {
                return;
            }
            
            
            try {
                // Initialize Select2 for dropdowns
                this.initializeSelect2();
                
                // Wait for destinations to be loaded by booking manager
                await this.waitForDestinations();
                
                // Load destinations for display
                await this.populateDestinations();
                
                // Restore form state from localStorage
                this.restoreFormState();
                
                // Populate mobile content
                this.populateMobileContent();
                
                // Setup event listeners
                this.setupEventListeners();
                
                this.isInitialized = true;
                
            } catch (error) {
                console.error('Failed to initialize shuttle header form:', error);
            }
        }
        
        /**
         * Wait for destinations to be loaded by booking manager
         */
        async waitForDestinations() {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max wait
            
            while (attempts < maxAttempts) {
                if (this.manager.destinations) {
                    return;
                }
                
                await new Promise(resolve => setTimeout(resolve, 100));
                attempts++;
            }
            
            throw new Error('Destinations not loaded within timeout');
        }
        
        /**
         * Initialize Select2 for From/To dropdowns
         */
        initializeSelect2() {
            // Initialize Select2 for From/To fields
            this.elements.fromSelectDesktop.select2({
                placeholder: 'From',
                allowClear: false,
                disabled: true // Disabled in header
            });
            
            this.elements.toSelectDesktop.select2({
                placeholder: 'To',
                allowClear: false,
                disabled: true // Disabled in header
            });
            
        }
        
        /**
         * Populate destinations for display
         */
        async populateDestinations() {
            try {
                const destinations = await this.manager.getDestinations();
                
                if (!destinations || (!destinations.airports && !destinations.resorts)) {
                    console.warn('No destinations available for header form');
                    return;
                }
                
                const airports = destinations.airports || [];
                const resorts = destinations.resorts || [];
                
                // Clear existing options
                this.elements.fromSelectDesktop.find('option:not(:first)').remove();
                this.elements.toSelectDesktop.find('option:not(:first)').remove();
                
                // Add airports group
                if (airports.length > 0) {
                    const airportsGroup = $('<optgroup label="Airports"></optgroup>');
                    airports.forEach(airport => {
                        // Try different property names for the label
                        const label = airport.name || airport.label || airport.title || `Airport ${airport.id}`;
                        airportsGroup.append(`<option value="${airport.id}">${label}</option>`);
                    });
                    this.elements.fromSelectDesktop.append(airportsGroup.clone());
                    this.elements.toSelectDesktop.append(airportsGroup.clone());
                }
                
                // Add resorts group
                if (resorts.length > 0) {
                    const resortsGroup = $('<optgroup label="Resorts"></optgroup>');
                    resorts.forEach(resort => {
                        // Try different property names for the label
                        const label = resort.name || resort.label || resort.title || `Resort ${resort.id}`;
                        resortsGroup.append(`<option value="${resort.id}">${label}</option>`);
                    });
                    this.elements.fromSelectDesktop.append(resortsGroup.clone());
                    this.elements.toSelectDesktop.append(resortsGroup.clone());
                }
                
                
            } catch (error) {
                console.error('Failed to populate header form destinations:', error);
            }
        }
        
        /**
         * Restore form state from localStorage
         */
        restoreFormState() {
            const data = this.manager.bookingData;
            if (!data) return;
            
            
            // Restore transfer type
            if (data.transferType) {
                this.elements.transferTypeRadios.filter(`[value="${data.transferType}"]`).prop('checked', true);
                this.updateTransferTypeUI(data.transferType);
            }
            
            // Restore From selection
            if (data.from && data.from.id) {
                // Check if option exists, if not add it
                const fromOption = this.elements.fromSelectDesktop.find(`option[value="${data.from.id}"]`);
                
                if (fromOption.length === 0) {
                    this.elements.fromSelectDesktop.append(`<option value="${data.from.id}">${data.from.label}</option>`);
                }
                
                this.elements.fromSelectDesktop.val(data.from.id);
                
                // Update Select2 display
                this.elements.fromSelectDesktop.trigger('change.select2');
                
                // Add floating label
                $('.shuttle-step-1__field--from .shuttle-step-1__floating-label').addClass('show');
            }
            
            // Restore To selection
            if (data.to && data.to.id) {
                // Check if option exists, if not add it
                const toOption = this.elements.toSelectDesktop.find(`option[value="${data.to.id}"]`);
                
                if (toOption.length === 0) {
                    this.elements.toSelectDesktop.append(`<option value="${data.to.id}">${data.to.label}</option>`);
                }
                
                this.elements.toSelectDesktop.val(data.to.id);
                
                // Update Select2 display
                this.elements.toSelectDesktop.trigger('change.select2');
                
                // Add floating label
                $('.shuttle-step-1__field--to .shuttle-step-1__floating-label').addClass('show');
            }
            
            // Restore date selections
            if (data.outboundDate) {
                this.elements.outboundDateDesktop.val(data.outboundDate).addClass('has-value');
                $('.shuttle-step-1__field--outbound-date .shuttle-step-1__date-floating-label').addClass('show');
            }
            
            if (data.returnDate && data.transferType === 'return') {
                this.elements.returnDateDesktop.val(data.returnDate).addClass('has-value');
                $('.shuttle-step-1__field--return-date .shuttle-step-1__date-floating-label').addClass('show');
            }
            
            // Restore passengers
            if (data.passengers) {
                const total = (data.passengers.adults || 1) + (data.passengers.children || 0);
                this.elements.passengersDesktop.val(total);
                $('.shuttle-step-1__passengers-count').text(total);
            }
            
            // Ensure all floating labels are visible (header design requirement)
            $('.shuttle-step-1__floating-label, .shuttle-step-1__date-floating-label').addClass('show');
        }
        
        /**
         * Populate mobile content
         */
        populateMobileContent() {
            const data = this.manager.bookingData;
            if (!data) return;
            
            // Populate outbound trip
            this.populateOutboundTrip(data);
            
            // Handle return trip if it's a return booking
            if (data.transferType === 'return') {
                this.populateReturnTrip(data);
                $('#shuttle-header-divider').show();
                $('#shuttle-header-return').show();
            } else {
                $('#shuttle-header-divider').hide();
                $('#shuttle-header-return').hide();
            }
        }
        
        /**
         * Populate outbound trip information
         */
        populateOutboundTrip(data) {
            // Format route text with arrow
            const fromLabel = data.from?.label || 'Unknown';
            const toLabel = data.to?.label || 'Unknown';
            const routeHtml = `${fromLabel} <span class="shuttle-step-header__route-arrow"></span> ${toLabel}`;
            
            // Format details text
            const date = data.outboundDate || '';
            const adults = data.passengers?.adults || 1;
            const children = data.passengers?.children || 0;
            
            let detailsText = date;
            if (adults > 0) {
                detailsText += `, ${adults} adult${adults > 1 ? 's' : ''}`;
            }
            if (children > 0) {
                detailsText += `, ${children} child${children > 1 ? 'ren' : ''}`;
            }
            
            // Update mobile content
            $('#shuttle-header-outbound-route').html(routeHtml);
            $('#shuttle-header-outbound-details').text(detailsText);
        }
        
        /**
         * Populate return trip information
         */
        populateReturnTrip(data) {
            // Format route text with arrow (reverse direction)
            const fromLabel = data.to?.label || 'Unknown';
            const toLabel = data.from?.label || 'Unknown';
            const routeHtml = `${fromLabel} <span class="shuttle-step-header__route-arrow"></span> ${toLabel}`;
            
            // Format details text
            const date = data.returnDate || '';
            const adults = data.passengers?.adults || 1;
            const children = data.passengers?.children || 0;
            
            let detailsText = date;
            if (adults > 0) {
                detailsText += `, ${adults} adult${adults > 1 ? 's' : ''}`;
            }
            if (children > 0) {
                detailsText += `, ${children} child${children > 1 ? 'ren' : ''}`;
            }
            
            // Update mobile content
            $('#shuttle-header-return-route').html(routeHtml);
            $('#shuttle-header-return-details').text(detailsText);
        }
        
        /**
         * Update transfer type UI
         */
        updateTransferTypeUI(transferType) {
            const isReturn = transferType === 'return';
            
            // Show/hide return date field
            $('.shuttle-step-1__field--return-date').toggle(isReturn);
            
            // Update form mode class
            this.form.toggleClass('shuttle-step-1__form--return-mode', isReturn);
        }
        
        /**
         * Setup event listeners
         */
        setupEventListeners() {
            // Back button
            this.elements.backBtn.on('click', (e) => {
                e.preventDefault();
                this.handleBackButton();
            });
        }
        
        /**
         * Handle back button click
         */
        handleBackButton() {
            this.manager.navigateBack();
        }
    }

    /**
     * Initialize when DOM is ready
     */
    $(document).ready(function() {
        // Only initialize if we're on a page with the header form
        if ($('#shuttle-booking-form-header').length > 0) {
            window.shuttleHeaderFormHandler = new ShuttleHeaderFormHandler();
        }
    });

})(jQuery);